import React from "react";
import WsrvImage from "../utils/WsrvImage";
import { getWsrvUrl } from "@/utils/wsrv";

export default function MainSection({ data }) {
  return (
    <>
      <div className="relative py-16">
        {/* Diagonal Background - optimized via wsrv */}
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('${getWsrvUrl(
              "https://i.filecdn.in/844twof/Rectangle72-1756289238376.png",
              { w: 1200, q: 75, output: "webp" }
            )}')`,
            clipPath: "polygon(0 0, 100% 0, 100% 50%, 0 100%)",
          }}
        ></div>

        {/* Content */}
        <div className="main  relative z-10">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-12 xl:gap-2 lg:gap-6 gap-4">
              <div className="space-y-8 mt-8 lg:col-span-7 col-span-12 ">
                {/* Top subtitle */}
                {data?.subHeading && (
                  <p className="text-[#000000] text-base font-medium  bg-white rounded-full py-1 md:w-[582px] w-full  text-center px-2   lg:m-0 m-auto lg:mb-8 ">
                    {data?.subHeading}
                  </p>
                )}

                {/* Main heading */}
                {data?.heading && (
                  <>
                    <div className="lg:text-start text-center md:space-y-2 space-y-4 lg:pt-4 pt-0 ">
                      <h1 className="text-5xl lg:text-[64px] font-medium text-[#000000] ">
                        {data?.heading.split("||")[0] && (
                          <span>{data?.heading.split("||")[0]}</span>
                        )}
                        {data?.heading.split("||")[1] && (
                          <span className="relative inline-block lg:w-[280px] left-4 lg:pl-3  w-[200px] mt-6">
                            <span className="text-gray-900">
                              {data?.heading.split("||")[1]}
                            </span>
                            <WsrvImage
                              src="https://i.filecdn.in/844twof/Vector7-1756288442758.png"
                              alt=""
                              widths={[200, 280, 400]}
                              sizes="280px"
                              width={280}
                              height={112}
                              className="w-full lg:h-[112px] h-auto xl:h-auto absolute top-[-31px] right-[10px] bottom-0"
                            />
                          </span>
                        )}
                      </h1>

                      {data?.heading.split("||")[2] && (
                        <h2 className="text-5xl lg:text-[64px] font-medium text-[#000000]">
                          {data?.heading.split("||")[2]}
                        </h2>
                      )}
                    </div>

                    {/* Subtitle */}
                    {(data?.heading.split("||")[3] ||
                      data?.heading.split("||")[4]) && (
                      <p className="text-5xl   lg:text-start font-thin text-center text-[#000000]">
                        {data?.heading.split("||")[3]}
                        <span className="text-4xl lg:text-[48px] font-medium text-[#000000] mx-2">
                          {data?.heading.split("||")[4]}
                        </span>
                      </p>
                    )}
                  </>
                )}

                {/* Dotted line */}
                <div className="border-t-2 border-dashed border-gray-400 md:w-80 w-72 lg:m-0 m-auto"></div>

                {/* Bottom tagline */}
                {data?.buttons?.length > 0 && (
                  <div className="space-y-2 lg:text-start text-center">
                    <p className="lg:text-2xl text-xl text-gray-600">
                      {data?.buttons[0].title}

                      <span className="font-medium text-[#404040] lg:text-[40px] text-[30px]">
                        {data?.buttons[1].title}
                      </span>
                    </p>
                    <p className="lg:text-2xl text-xl text-gray-600 text-center">
                      {data?.buttons[2].title}
                      <span className="font-medium text-[#404040] lg:text-[40px] text-[30px] ml-1">
                        {data?.buttons[3].title}
                      </span>
                    </p>
                  </div>
                )}
              </div>

              {/* Right side content/image can go here - LCP candidate */}
              {data?.media && (
                <div className="flex  justify-center lg:col-span-5 col-span-12">
                  <div className="img max-w-[492px]">
                    <WsrvImage
                      src={data.media}
                      alt={data.heading?.split("||")[0] || "CLC Feature"}
                      priority
                      width={492}
                      height={600}
                      sizes="(max-width: 1024px) 100vw, 492px"
                      widths={[320, 480, 640, 750, 828, 1080]}
                      className="w-full h-auto"
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
